import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.0038 1L15.743 7.4432L23.0038 9.02129L18.0538 14.5815L18.8022 22L12.0038 18.9932L5.20547 22L5.95385 14.5815L1.00385 9.02129L8.26474 7.4432L12.0038 1Z",
      fill: "#8A688E"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15.743 7.4432L12.0038 1L8.26474 7.4432L1.00385 9.02129L5.95385 14.5815L5.20547 22L12.0038 18.9932L18.8022 22L18.0538 14.5815L23.0038 9.02129L15.743 7.4432Z",
      fill: "#8A688E"
    }, null, -1)
  ])))
}
export default { render: render }